import { OptionalRange } from "../../types";
import { DateRange } from "../Date";

interface IDateRange {
  start?: string | null;
  end?: string | null;
}

interface ICreateDefaultBackfillFilters {
  status?: string | null;
  createdRange?: IDateRange;
  reportRange?: IDateRange;
}

type DefaultBackfillFilters = {
  status: string;
  createdRange: OptionalRange<Date>;
  reportRange: OptionalRange<Date>;
};

export const createDefaultBackfillFilters = ({
  status,
  createdRange,
  reportRange,
}: ICreateDefaultBackfillFilters): DefaultBackfillFilters => {
  return {
    status: status || "",
    createdRange:
      createdRange?.start && createdRange?.end
        ? (DateRange.fromString(createdRange.start, createdRange.end)?.toDateRange() ?? {
            start: undefined,
            end: undefined,
          })
        : { start: undefined, end: undefined },
    reportRange:
      reportRange?.start && reportRange?.end
        ? (DateRange.fromString(reportRange.start, reportRange.end)?.toDateRange() ?? {
            start: undefined,
            end: undefined,
          })
        : { start: undefined, end: undefined },
  };
};
